import { Button } from "@mui/material";
import React, { useContext } from "react";
import { Container } from "./styles";
import EmployeeCostExportAction from "./EmployeeCostExportAction/EmployeeCostExportAction";
import EmployeeCostSendAction from "./EmloyeeCostSendAction/EmployeeCostSendAction";
import { UserRef } from "../../../models/user";
import { ProformaEmployeeCostReportContext } from "../ProformaEmployeeCostReport/ProformaEmployeeCostReport";
import { useTranslation } from "react-i18next";

interface Props {
  forceCloseSendDialog: boolean;
  handleSaveReport: () => Promise<void>;
  preHandleExport: (
    paySchema: boolean,
    costSchema: boolean,
    sectionsWithZeroAmount: boolean,
    saveBefore: boolean,
    monthlyView: boolean
  ) => Promise<void>;
  prehandleSend: (
    paySchema: boolean,
    costSchema: boolean,
    sectionsWithZeroAmount: boolean,
    users: UserRef[],
    externalUsers: string[],
    monthlyView: boolean
  ) => Promise<void>;
  allFieldsValidated: boolean;
}

const EmployeeCostActions = ({
  forceCloseSendDialog,
  handleSaveReport,
  preHandleExport,
  prehandleSend,
  allFieldsValidated,
}: Props) => {
  const { t } = useTranslation();
  const { viewMode } = useContext(ProformaEmployeeCostReportContext);

  return (
    <Container>
      <EmployeeCostSendAction
        preHandleSend={prehandleSend}
        forceClose={forceCloseSendDialog}
        allFieldsValidated={allFieldsValidated}
      />
      <EmployeeCostExportAction
        preHandleExport={preHandleExport}
        allFieldsValidated={allFieldsValidated}
      />

      {!viewMode && (
        <Button
          variant="contained"
          onClick={handleSaveReport}
          title={!allFieldsValidated ? "All fields must be validated before saving" : "Save"}
          disabled={!allFieldsValidated}
          style={{
            pointerEvents: "auto",
          }}
        >
          {`${t(`buttons.save`)}`}
        </Button>
      )}
    </Container>
  );
};
export default EmployeeCostActions;
